export default {
  en: {
    navigation: 'Quick Links',
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    news: 'News',
    contact: 'Contact Us',
    support: 'Support',
    faq: 'FAQ',
    userGuide: 'User Guide',
    common: {
      home: 'Home'
    }
  },
  zh: {
    navigation: '导航',
    home: '首页',
    about: '关于我们',
    products: '产品中心',
    news: '新闻',
    contact: '联系我们',
    support: '支持',
    faq: '常见问题',
    userGuide: '用户指南',
    common: {
      home: '首页'
    }
  }
}